import { TrainingModel } from '@modules/training/training-model';

const { fields } = TrainingModel;

export default [
  fields.title,
  fields.description,
  fields.date,
  fields.hour,
  fields.duration,
  fields.location,
  fields.status,
  fields.team,
];
